export var SessionStorageKeys;
(function (SessionStorageKeys) {
    SessionStorageKeys["firstTimeOnCommunityDashboard"] = "firstTimeOnCommunityDashboard";
    SessionStorageKeys["practitionerInvitedPrincipalIdNumber"] = "practitionerInvitedPrincipal";
    SessionStorageKeys["practitionerInvitedPrincipalUserId"] = "practitionerInvitedPrincipalUserId";
    SessionStorageKeys["selectedUser"] = "selectedUser";
    SessionStorageKeys["selectedMessage"] = "selectedMessage";
    SessionStorageKeys["passwordResetEmail"] = "passwordResetEmail";
})(SessionStorageKeys || (SessionStorageKeys = {}));
//# sourceMappingURL=session-storage-keys.js.map